import { UserProps } from '@elsevier-health/osmosis-shared/types/user';
import { sha256 } from './crypto';

/**
 * Initializes GTM.
 */
export const gtmInitializer = async (user?: UserProps | null) => {
  if (typeof window !== 'object') return;

  const gtmId = process.env.NEXT_PUBLIC_GTM_ID;

  (function (w: any, d: any, s: any, l: any, i: any) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://osmosis.org/fps/gtm.js?id=' + gtmId + dl;
    f?.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', gtmId);

  const loggedIn = !!user?.userID;
  const needsLogin = false;
  const hashedUserID = user?.userID ? await sha256(user.userID.toString()) : '';
  const hashedEmail = user?.email ? await sha256(user.email.toLowerCase()) : '';
  const dataLayerArgs = {
    loggedIn,
    needsLogin,
    userID: hashedUserID,
    email: hashedEmail,
  };

  window.dataLayer = window.dataLayer || [];

  try {
    let tests = Object.entries(localStorage)
      .filter(([key, value]) => key.startsWith('Test:'))
      .reduce((memo: { name: string; group: any }[], [key, value]) => {
        return memo.concat({ name: key, group: JSON.parse(value).version });
      }, []);

    tests = document.cookie
      .split(';')
      .map((item) => {
        const [_key, value] = item.split('=');
        const key = _key.trim();

        return { key, value };
      })
      .reduce((memo, { key, value }) => {
        if (!key.startsWith('test-')) return memo;

        return memo.concat({
          name: key,
          group: JSON.parse(decodeURIComponent(value)).version,
        });
      }, tests);

    const data = Object.assign(
      {
        needsLogin: false,
        loggedIn: false,
      },
      dataLayerArgs,
      {
        tests: tests,
      },
    );

    window.dataLayer.push(data);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Unable to initialize GTM onload data');
  }
};
